import axiApi from "ApiCaller";
import {useTranslation} from "react-i18next";
import {useEffect, useState, useRef, useContext} from "react";
// -
import NavBreadcrum from "components/NavBreadcrum";
import TopBarActions from "components/TopBarActions";
import TableAssetGroup from "./group/TableAssetGroup";
import ButtonsActions from "views/utils/buttonsActions";
import PreviewGroup from "./group/PreviewGroup";
import GroupAssetModel from "site-apps/assets/GroupAssetModel";
import navs from "./navs";
import AuthContext from "context/AuthContext";
import LoaderSpinner from "context/LoaderSpinner";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import ItemsModel from "core/itemsModel";
import {toLowCaseCleanSpaces} from "core/utils/Texts";
import {SwalAlertClass, SwalAlertChoice} from "core/swalClass";
import FilterModel from "../../components/FilterModel";
import {useSearchParams} from "react-router-dom";
import {translations} from "./translations";
import useCustomTranslation from "core/customTranslation";
import OrderingModel from "components/ordering/OrderingModel";

const buttonsActions = new ButtonsActions();

const ViewAssetGroups = () => {
    const {user} = useContext(AuthContext);

    const {t: _Tr} = useTranslation("routes");
    const {t: _Tc} = useCustomTranslation(translations);
    const {t: _Tt} = useTranslation("tables");
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});

    const AlertQuestion = new SwalAlertChoice({
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
    });
    const items = useRef(new ItemsModel());
    const [itemsShow, setItemsShow] = useState([]);
    const [item, setItem] = useState({...GroupAssetModel});
    const [showPrev, setShowPrev] = useState(false);
    const [buttonsTB, setButtonsTB] = useState(buttonsActions);
    const [selectAll, setSelectAll] = useState(false);

    const [urlQuery] = useSearchParams();
    const filters = useRef(new FilterModel());
    const pagerModelRef = useRef(new PagerModel());
    const [isLoading, setIsLoading] = useState(false);
    const orderingRef = useRef(new OrderingModel());

    const bread = [
        {
            name: _Tr("labels.asset-management"),
            url: "/asset-management/",
            current: false,
        },
        {name: _Tr("labels.groups"), current: true},
    ];

    const headersTable = [
        {name: _Tt("group.name"), attr: 0, direction: "asc", active: true, default: true},
        {name: _Tt("group.assets_count"), attr: 1, direction: "asc", active: false},
    ];

    useEffect(() => {
        const canEdit = user.is_superuser || user.is_admin;
        const title = _Tr("labels.groups");
        document.title = title;
        const buttons = {...buttonsTB};
        buttons.title = title;
        buttons.add.active = canEdit;
        buttons.add.disabled = !canEdit;
        buttons.add.onClick = onClickAdd;
        buttons.delete.active = canEdit;
        buttons.delete.disabled = !canEdit || items.current.chosen.length === 0;
        buttons.delete.onClick = onClickDelete;
        setButtonsTB(buttons);
        pagerModelRef.current.active = true;
        pagerModelRef.current.handleCallApi = () => fetchApiData();
        orderingRef.current.setHeaders(headersTable);
        orderingRef.current.applyOrder = () => {
            applyFilters();
        };
        items.current.setItem = setItem;
        items.current.setShowPrev = setShowPrev;
        items.current.item = GroupAssetModel;

        getDataGroups();
    }, []);

    filters.current.filter = () => {
        pagerModelRef.current.paging.page = 1;
        const buttons = {...buttonsTB};
        buttons.filter.applied = true;
        setButtonsTB(buttons);
        fetchApiData();
    };

    function onClickAdd() {
        setItem({...GroupAssetModel});
        setShowPrev(true);
    }

    const urlQueryParams = () => {
        if (urlQuery.has("id")) {
            let id = urlQuery.get("id");
            filters.current.searcher.ref.value = id;
            filters.current.chosen.searcher = toLowCaseCleanSpaces(id);
            filters.current.filter();
        }
    };
    const onClickDelete = () => {
        AlertQuestion.warning(_Tc("alert.delete"), `Se borraran los ${items.current.chosen.length} seleccionados`).then(
            (resp) => {
                if (resp.isConfirmed) {
                    let ids = [];
                    ids = items.current.getChosenIds();
                    axiApi
                        .delete(`/api/assets/groups/`, {data: {ids: ids}})
                        .then((resp) => {
                            if (resp.data.status) {
                                setItemsShow(items.current.showed.filter((_item) => !ids.includes(_item.id)));
                                setShowPrev(false);
                                items.current.clearChosen();
                                Alert.success(_Tc("alert.delete.success"), `${ids.length} ${_Tc("alert.delete.groups")}`);
                            } else {
                                console.log("error al borrar el grupo");
                                resp.data.message && console.error(resp.data.message);
                                Alert.warning(_Tc("notify.admin"), _Tc("alert.service.error"));
                            }
                        })
                        .catch((error) => {
                            console.error("Error al enviar la solicitud:", error);
                        });
                }
            }
        );
    };

    const getDataGroups = async () => {
        setIsLoading(true);
        try {
            const resp = await axiApi.get("/api/assets/groups/", filters.current.chosen);
            if (resp.data) {
                items.current.showed = [...resp.data.items];
                setItemsShow(items.current.showed);
                if (resp.data.pager) {
                    pagerModelRef.current.paging.update(resp.data.pager);
                }
                urlQueryParams();
            }
        } catch (error) {
            console.error("Error fetching groups:", error);
            const buttons = {...buttonsTB};
            buttons.filter.applied = false;
            setButtonsTB(buttons);
        }
        setIsLoading(false);
    };

    const fetchApiData = async () => {
        setIsLoading(true);
        try {
            const resp = await axiApi.post("/api/assets/groups/", filters.current.chosen, {
                params: pagerModelRef.current.paging.getParams(),
            });

            if (resp.data) {
                items.current.setShowed(resp.data.items);
                setItemsShow([...resp.data.items]);
                if (resp.data.pager) {
                    pagerModelRef.current.paging.update(resp.data.pager);
                }
            }
        } catch (error) {
            console.error("Error fetching groups:", error);
            const buttons = {...buttonsTB};
            buttons.filter.applied = false;
            setButtonsTB(buttons);
        }
        setIsLoading(false);
    };

    const applyFilters = () => {
        setIsLoading(true);
        axiApi
            .post("/api/assets/groups/", filters.current.chosen, {
                params: {
                    ...pagerModelRef.current.paging.getParams(),
                    ...orderingRef.current.getParams(),
                },
            })
            .then((resp) => {
                if (resp.data) {
                    items.current.setShowed(resp.data.items);
                    setItemsShow([...resp.data.items]);
                    if (resp.data.pager) {
                        pagerModelRef.current.paging.update(resp.data.pager);
                    }
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
                const buttons = {...buttonsTB};
                buttons.filter.applied = false;
                setButtonsTB(buttons);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <TopBarActions actions={buttonsTB} filtersRef={filters} />
            <TopBarPagination pagerModel={pagerModelRef.current} stickyTopValue="125px" chosen={items.current.chosen} />
            <div className="row">
                <div className="col-md col-12" style={{width: "40%"}}>
                    <LoaderSpinner isLoading={isLoading}>
                        <TableAssetGroup
                            itemsShow={itemsShow}
                            items={items}
                            checkAll={selectAll}
                            setCheckAll={setSelectAll}
                            buttonsTB={buttonsTB}
                            setButtonsTB={setButtonsTB}
                            orderingRef={orderingRef}
                        />
                    </LoaderSpinner>
                </div>
                <PreviewGroup
                    item={item}
                    setItem={setItem}
                    items={items}
                    setItemsShow={setItemsShow}
                    setShowPrev={setShowPrev}
                    showPrev={showPrev}
                />
            </div>
        </>
    );
};
export default ViewAssetGroups;
